export type MapOverlayEvent = google.maps.MapMouseEvent | google.maps.PolyMouseEvent;

export interface BindMapOverlayContextMenuOptions {
  beforeOpen?: (event: MapOverlayEvent) => void;
  canOpen?: (event: MapOverlayEvent) => boolean;
}

function getClientPosition(domEvent: Event | null | undefined): { x: number; y: number } | null {
  if (!domEvent) return null;

  if ('clientX' in domEvent && 'clientY' in domEvent) {
    const mouseEvent = domEvent as MouseEvent;
    return { x: mouseEvent.clientX, y: mouseEvent.clientY };
  }

  return null;
}

function stopDomEvent(domEvent: Event | null | undefined) {
  if (!domEvent) return;
  domEvent.preventDefault();
  domEvent.stopPropagation();
  if ('stopImmediatePropagation' in domEvent) {
    domEvent.stopImmediatePropagation();
  }
}

/**
 * Abre menu de contexto com botão direito (desktop) em overlays do Google Maps.
 * No mobile, use o InfoWindow com botões de ação (toque longo desativado).
 */
export function bindMapOverlayContextMenu(
  target: google.maps.MVCObject,
  handler: (clientX: number, clientY: number, event: MapOverlayEvent) => void,
  options?: BindMapOverlayContextMenuOptions,
): void {
  let lastOpenAt = 0;

  const openMenu = (clientX: number, clientY: number, event: MapOverlayEvent) => {
    if (options?.canOpen && !options.canOpen(event)) return;

    const now = Date.now();
    if (now - lastOpenAt < 300) return;
    lastOpenAt = now;

    options?.beforeOpen?.(event);
    stopDomEvent(event.domEvent ?? undefined);
    handler(clientX, clientY, event);
  };

  target.addListener('rightclick', (event: MapOverlayEvent) => {
    const position = getClientPosition(event.domEvent ?? undefined);
    openMenu(
      position?.x ?? window.innerWidth / 2,
      position?.y ?? window.innerHeight / 2,
      event,
    );
  });
}
